import React from "react";
import { navigate } from "@shared/utils.routing";
import type { DiscoveryJourneySlides, SlideButtonActions } from "../types";
import {
  WelcomeSlide,
  WelcomeSlideCTA,
  ActiveBenefitsSlideCTA,
  ActiveBenefitsSlide,
  RedeemedBenefitsSlide,
  RedeemedBenefitsSlideCTA,
  NoActiveMembershipSlide,
  NoActiveMembershipSlideCTA
} from "./slides/index";

type Props = SlideButtonActions & {
  slides: DiscoveryJourneySlides[];
  currentSlideIndex: number;
  setNextVisibility: (visible: boolean, next?: () => void) => void;
};

export const slides = ({
  slides: journeySlides,
  currentSlideIndex,
  backToPreviousSlide,
  goToNextSlide,
  setNextVisibility
}: Props): { component: JSX.Element; cta?: JSX.Element } => {
  const currentSlide =
    journeySlides.length > 0 && journeySlides[currentSlideIndex]?.id;
  const isActiveBenefitsLastSlide = !journeySlides.some(
    (slide) => slide.id === "REDEEMED_BENEFITS"
  );
  const isRedeemedBenefitsLastSlide = !journeySlides.some(
    (slide) => slide.id === "NO_ACTIVE_MEMBERSHIP"
  );

  const navigateToMemberBenefitsPage = () => {
    const url = "account/member-benefits";
    setNextVisibility(false, () => navigate(`/${url}`));
  };

  const navigateToJoinNowPage = () => {
    const url = "bp/join/join-beauty-pie";
    setNextVisibility(false, () => navigate(`/${url}`));
  };

  switch (currentSlide) {
    case "WELCOME_SLIDE":
      return {
        component: <WelcomeSlide />,
        cta: <WelcomeSlideCTA goToNextSlide={goToNextSlide} />
      };
    case "ACTIVE_BENEFITS":
      return {
        component: <ActiveBenefitsSlide />,
        cta: (
          <ActiveBenefitsSlideCTA
            backToPreviousSlide={backToPreviousSlide}
            goToNextSlide={goToNextSlide}
            isActiveBenefitsLastSlide={isActiveBenefitsLastSlide}
            navigateToMemberBenefitsPage={navigateToMemberBenefitsPage}
          />
        )
      };
    case "REDEEMED_BENEFITS":
      return {
        component: <RedeemedBenefitsSlide />,
        cta: (
          <RedeemedBenefitsSlideCTA
            backToPreviousSlide={backToPreviousSlide}
            goToNextSlide={goToNextSlide}
            navigateToMemberBenefitsPage={navigateToMemberBenefitsPage}
            isRedeemedBenefitsLastSlide={isRedeemedBenefitsLastSlide}
          />
        )
      };
    case "NO_ACTIVE_MEMBERSHIP":
      return {
        component: (
          <NoActiveMembershipSlide
            navigateToJoinNowPage={navigateToJoinNowPage}
          />
        ),
        cta: (
          <NoActiveMembershipSlideCTA
            backToPreviousSlide={backToPreviousSlide}
            goToNextSlide={goToNextSlide}
            navigateToJoinNowPage={navigateToJoinNowPage}
          />
        )
      };
    default:
      return { component: <></>, cta: <></> };
  }
};
